export const apiKey = 'AIzaSyB1NhC9asflKjCq1bkj3pItLAA3FmGXYlQ'

export const uris = {
  topoJson: './_data_/topojson-reduced.json',
  data: '1yL1vzq06roAU62Cz9PSDw2HtB7tXkQKyO8JmQOzzPHo',
  anonData: '1Z7GAHghvW8uKL191qgVPttVrowwL9yCTpEWK7832b5c',
  newAnonData: '1B9pUq5ymnwc9rdiAl7sdFcKqGf9Afjhijs3MJtfnE4o'
}

export const mastheadConfig = {
  mediaName: 'derbund',
  fullMediaName: 'Der Bund',
  homepage: '//www.derbund.ch'
}

const colors = {
  city: 'rgba(226, 164, 158, 1)',
  burger_zunft: 'rgba(139, 114, 142, 1)',
  church: 'rgba(0, 161, 202, 1)',
  society: 'rgba(249, 79, 88, 1)',
  commercial: 'rgba(14, 147, 125, 1)',
  investor: 'rgba(0, 255,255, 1)',
  private: 'rgba(36, 123, 160, 1)'
}

export const categories = [
  // menu-buttons
  {
    name: 'city',
    displayName: 'Staatlich',
    color: colors.city,
    type: 'menu',
    code: [1, 11, 12, 13, 15, 16, 17],
    parent: 1
  },
  {
    name: 'burger_zunft',
    displayName: 'Burger/Zünfte',
    color: colors.burger_zunft,
    type: 'menu',
    code: [2, 21, 22],
    parent: 2
  },
  {
    name: 'church',
    displayName: 'Kirchen',
    color: colors.church,
    type: 'menu',
    code: [3],
    parent: 3
  },
  {
    name: 'society',
    displayName: 'Vereine',
    color: colors.society,
    type: 'menu',
    code: [4, 41, 42],
    parent: 4
  },
  {
    name: 'commercial',
    displayName: 'Unternehmen',
    color: colors.commercial,
    type: 'menu',
    code: [5, 51, 52],
    parent: 5
  },
  {
    name: 'investor',
    displayName: 'Investoren',
    color: colors.investor,
    type: 'menu',
    code: [6, 61, 62, 63],
    parent: 6
  },
  {
    name: 'private',
    displayName: 'Private',
    color: colors.private,
    type: 'menu',
    code: [7],
    parent: 7
  },
  // filter buttons
  // city
  {
    name: 'all-city',
    displayName: 'Alle',
    color: colors.city,
    type: 'filter',
    code: [1, 11, 12, 13, 15, 16, 17],
    parent: 1
  },
  {
    name: 'immoBern',
    displayName: 'Stadt Bern',
    color: colors.city,
    type: 'filter',
    code: 11,
    parent: 1
  },
  {
    name: 'fonds',
    displayName: 'Fonds für Boden- und Wohnbau',
    color: colors.city,
    type: 'filter',
    code: 12,
    parent: 1
  },
  {
    name: 'tiefbauamt',
    displayName: 'Tiefbauamt',
    color: 'filter',
    type: colors.city,
    code: 13,
    parent: 1
  },
  {
    name: 'kanton',
    displayName: 'Kanton Bern',
    color: colors.city,
    type: 'filter',
    code: 15,
    parent: 1
  },
  {
    name: 'bund',
    displayName: 'Bund',
    color: colors.city,
    type: 'filter',
    code: 16,
    parent: 1
  },
  {
    name: 'ORAnst',
    displayName: 'öff-recht. Anst.',
    color: colors.city,
    type: 'filter',
    code: 17,
    parent: 1
  },
  // Burger, Zünfte
  {
    name: 'all-zunft',
    displayName: 'Alle',
    color: colors.burger_zunft,
    type: 'filter',
    code: [2, 21, 22],
    parent: 2
  },
  {
    name: 'burger',
    displayName: 'Burgergemeinde',
    color: colors.burger_zunft,
    type: 'filter',
    code: 21,
    parent: 2
  },
  {
    name: 'zunft',
    displayName: 'Zünfte',
    color: colors.burger_zunft,
    type: 'filter',
    code: 22,
    parent: 2
  },
  // Kirchen
  {
    name: 'all-churches',
    displayName: 'Kirchen',
    color: colors.church,
    type: 'filter',
    code: 3,
    parent: 3
  },
  // Gesellschaften
  {
    name: 'all-society',
    displayName: 'Alle',
    color: colors.society,
    type: 'filter',
    code: [4, 41, 42],
    parent: 4
  },
  {
    name: 'vereine',
    displayName: 'Vereine',
    color: colors.society,
    type: 'filter',
    code: 41,
    parent: 4
  },
  {
    name: 'stiftung',
    displayName: 'Stiftung',
    color: colors.society,
    type: 'filter',
    code: 42,
    parent: 4
  },
  // Firmen
  {
    name: 'all-commercial',
    displayName: 'Alle',
    color: colors.commercial,
    type: 'filter',
    code: [5, 51, 52],
    parent: 5
  },
  {
    name: 'ag-gmbh',
    displayName: 'AG/GmbH',
    color: colors.commercial,
    type: 'filter',
    code: 51,
    parent: 5
  },
  {
    name: 'genossenschaft',
    displayName: 'Genossenschaft',
    color: colors.commercial,
    type: 'filter',
    code: 52,
    parent: 5
  },
  // Investoren
  {
    name: 'all-investor',
    displayName: 'Alle',
    color: colors.investor,
    type: 'filter',
    code: [6, 61, 62, 63],
    parent: 6
  },
  {
    name: 'priv-pk',
    displayName: 'Private PK',
    color: colors.investor,
    type: 'filter',
    code: 61,
    parent: 6
  },
  {
    name: 'publik-pk',
    displayName: 'staatliche PK',
    color: colors.investor,
    type: 'filter',
    code: 62,
    parent: 6
  },
  {
    name: 'immo',
    displayName: 'Immobilien-Gesellschaft',
    color: colors.investor,
    type: 'filter',
    code: 63,
    parent: 6
  },
  // Private
  {
    name: 'all-private',
    displayName: 'Private',
    color: colors.private,
    type: 'filter',
    code: 7,
    parent: 7
  }
]

export const parzToExclude = [
  296,
  1441,
  1360,
  1448,
  1400,
  1425,
  1401,
  1430,
  1467,
  1474,
  1399,
  1424,
  1449,
  1408,
  1519,
  1407
]

export const colorCodes = ((cats) => {
  return cats
    .filter((el) => {
      return el.type === 'menu'
    })
    .reduce((result, el) => {
      result[el.code[0]] = el.color
      return result
    }, {})
})(categories)

export const ownerCodes = ((cats) => {
  return cats
    .filter((el) => {
      return el.type === 'menu'
    })
    .reduce((result, el) => {
      result[el.code[0]] = el.displayName
      return result
    }, {})
})(categories)



// WEBPACK FOOTER //
// ./src/config/config.js